import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { runTask, pollTask, runDisposables } from 'ember-lifeline';
import config from '@banking/savings-onboarding-app/config/environment';
import { routeForStatusDuringPleaseWait } from '../../utils/signup/route-for-application-status';

export const POLL_TOKEN = 'please-wait';
export const TIMEOUT_MILLISECONDS = 60 * 1000;

export default class PleaseWaitRoute extends Route {
  @service currentApplicationFlow;
  @service features;

  activate() {
    this.activatedAt = Date.now();
    pollTask(this, 'retrieveApplicationFlow', POLL_TOKEN);
  }

  deactivate() {
    runDisposables(this);
  }

  timeoutOrRerun(next) {
    if (Date.now() - this.activatedAt >= TIMEOUT_MILLISECONDS) {
      this.replaceWith('signup.timeout');
    } else {
      runTask(this, next, config.APP.pleaseWaitPollDelayMs);
    }
  }

  async retrieveApplicationFlow(next) {
    try {
      const status = await this.currentApplicationFlow.refreshStatus();
      const doNotPrefill = this.features.isEnabled(
        'banking/stop_prefilling_savings_onboarding'
      );
      const route = routeForStatusDuringPleaseWait(status, doNotPrefill);
      if (!route) {
        // NOTE: to test this, set app flow state to an invalid or null value in testing (or null above)
        const error = new Error(`unexpected ApplicationFlow status: ${status}`);
        this.send('handleRpcError', error);
      } else if (route === 'signup.please-wait') {
        this.timeoutOrRerun(next);
      } else if (
        route === 'signup.confirm-identity' ||
        route === 'signup.confirm-identity.edit' ||
        route === 'signup.two-factor' ||
        route === 'signup.enter-identity-info'
      ) {
        this.currentApplicationFlow.didFailIdv = true;
        // cache the new value with updated status
        await this.currentApplicationFlow.retrieve(
          this.currentApplicationFlow.id
        );
        this.replaceWith(route);
      } else {
        // cache the new value with updated status
        await this.currentApplicationFlow.retrieve(
          this.currentApplicationFlow.id
        );
        this.replaceWith(route);
      }
    } catch {
      // we will retry 5xx requests at a lower level so if we got here we have
      // already tried multiple times
      this.timeoutOrRerun(next);
    }
  }
}
